import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonCategorie = () => {
    return (
        <div className="w-full max-w-md mx-auto">
            <div className="flex overflow-x-auto gap-4 pt-2 scrollbar-hide px-1">
                {[...Array(5)].map((_, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center justify-center min-w-[76px] px-1"
                    >
                        {/* Cerchio dell'icona (h-14 = 56px per pareggiare Category md) */}
                        <Skeleton
                            circle
                            height={56}
                            width={56}
                            baseColor="#121824"
                            highlightColor="#1A2234"
                            className="opacity-60 shadow-md"
                        />
                        {/* Testo sotto l'icona */}
                        <Skeleton
                            width={50}
                            height={10}
                            className="mt-2 text-[11px]"
                            baseColor="#121824"
                            highlightColor="#1A2234"
                            className="opacity-60"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SkeletonCategorie;